import Modal from 'react-bootstrap/Modal'

interface IModalProps {
    show: boolean
    onHide: () => void
    type: 'submit'
}
const ProfileModal = ({ show, onHide, type }: IModalProps) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p>بعد از ثبت، اطلاعات تکمیل شده قابل تغییر و تعویض نیستند</p>
                <hr className=" my-2" />
                <button
                    className=" text-xs text-current"
                    type={type}
                    form="authProfile"
                >
                    تایید
                </button>
                <hr className=" my-2" />
                <p className=" text-xs cursor-pointer" onClick={onHide}>
                    بازگشت
                </p>
            </div>
        </Modal>
    )
}

export default ProfileModal
